module.exports = __webpack_public_path__ + "img/praxis_VCG.fd933a33.png";